// extracted by mini-css-extract-plugin
export default {"error-text":"Profile_error-text__6-N-r","card-wrapper":"Profile_card-wrapper__wPi4g","content-wrapper":"Profile_content-wrapper__r1JKs","title":"Profile_title__2Y+32"};